import { _t } from "@cruisen/i18n"
import { UserID } from "@cruisen/contract"
import styles from "./styles.module.scss"

export const CreatedWelcomeMessage = ({
  userFirstName,
  userId,
  currentUserId,
}: {
  userFirstName: string
  userId: UserID
  currentUserId: UserID
}) => {
  if (currentUserId !== userId) return null

  return (
    <>
      <div className={styles.firstBox}>
        <p>{_t("navigatorSystemMessageComponents.createTripWelcomeOne", { userFirstName })}</p>
      </div>
      <div className={styles.secondBox}>
        <p>{_t("navigatorSystemMessageComponents.createTripWelcomeTwo", { userFirstName })}</p>
      </div>
    </>
  )
}
